import { asRecord } from '@/utils/coerce'
import type { MaterialOverrides } from '@/types/api'

export const FALLBACK_MATERIAL = 'Standard'

export const CREATE_MATERIAL = '__create__'

export const UNIT_PARAMS = ['Metallic', 'Roughness', 'Glass', 'Alpha'] as const

export function resolveOverrides(raw: unknown): MaterialOverrides {
  const source = asRecord(raw)
  const out: MaterialOverrides = {}

  for (const [slot, value] of Object.entries(source)) {
    if (!slot) continue
    if (typeof value === 'string' && value.trim()) out[slot] = value.trim()
  }

  return out
}
